import { TEE_COLOR_MAP, TEE_COLORS } from '@/constants';
import { CourseModel } from '../models/CourseModels';

interface GetTeeColorsOptions {
    currentHole?: number;
    currentYards?: number;
    courseModel?: CourseModel | null;
}

export const getTeeColors = (teeName: string, options: GetTeeColorsOptions = {}, defaultColors = TEE_COLOR_MAP[TEE_COLORS.DEFAULT]) => {
    const { currentHole, currentYards, courseModel: courseModel } = options;

    // console.log('teeName', teeName);

    // Handle combination tees (e.g., "Blue/White")
    if (teeName.includes('/')) {
        const [firstColor, secondColor] = teeName.split('/').map(c => c.trim());

        // console.log('firstColor, secondColor', firstColor, secondColor);
        // console.log('course', course);
        // console.log('currentHole', currentHole);
        // console.log('currentYards', currentYards);

        if (courseModel && currentHole !== undefined && currentYards !== undefined) {
            const currentHoleInfo = courseModel.scorecard.holes[currentHole - 1];
            //console.log('currentHoleInfo', currentHoleInfo);
            if (currentHoleInfo) {
                // Find a tee with matching yards
                const matchingTee = currentHoleInfo.tees.find(t => t.yards === currentYards && t.name.toLowerCase() !== teeName.toLowerCase());
                //console.log('matchingTee', matchingTee);
                if (matchingTee) {
                    // If the matching tee's name contains the first color, use that color
                    if (matchingTee.name.toLowerCase().includes(firstColor.toLowerCase())) {
                        const colors = TEE_COLOR_MAP[firstColor];
                        return colors ? { ...colors, content: firstColor } : { ...defaultColors, content: firstColor };
                    }
                    // If the matching tee's name contains the second color, use that color
                    if (matchingTee.name.toLowerCase().includes(secondColor.toLowerCase())) {
                        const colors = TEE_COLOR_MAP[secondColor];
                        return colors ? { ...colors, content: secondColor } : { ...defaultColors, content: secondColor };
                    }
                }
            }
        }
        // If we can't determine which color to use, default to the first color
        const colors = TEE_COLOR_MAP[firstColor];
        return colors ? { ...colors, content: firstColor } : { ...defaultColors, content: firstColor };
    }

    // Default color handling for single color tees
    const normalizedTeeName = teeName.toLowerCase();
    for (const [color, values] of Object.entries(TEE_COLOR_MAP)) {
        if (normalizedTeeName.includes(color.toLowerCase())) {
            return { ...values, content: teeName };
        }
    }

    // Default colors if no match
    return { ...defaultColors, content: teeName };
}; 